import './PracticePitcherSessionPitchTypeRangesChart.scss';

import { PitchTypeRangesChartConfigDto, PitchTypeRangesChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/PracticeReport/Pitcher/reportStore';
import PitchTypeRangesChart from 'components/Charts/PitchTypeRangesChart/PitchTypeRangesChart';

const PracticePitcherSessionPitchTypeRangesChart = (props: ChartProps<PitchTypeRangesChartDataDto, PitchTypeRangesChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PracticePitcherSessionPitchTypeRangesChart-container'>
      <PitchTypeRangesChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />
    </div>
  );
};

export default PracticePitcherSessionPitchTypeRangesChart;
